import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

export const StyledFaqAccordion = styled.div<{
  borderColor?: string
  bgContentColor?: string
}>`
  &[data-template='health-tool'],
  &[data-template='due-date'] {
    .accordion {
      .mantine-Accordion-control {
        padding: 12px 0;
        border-bottom: 1px solid ${(props) => props.borderColor};
      }
      .mantine-Accordion-panel {
        padding: 0;
      }
      .mantine-Accordion-label {
        overflow: unset;
      }
      .mantine-Accordion-item {
        border: none;
        &[data-active='true'] {
          .mantine-Accordion-label .mantine-Text-root {
            font-weight: 700;
          }
        }
        &:last-child {
          .mantine-Accordion-control {
            border-bottom: none;
          }
        }
      }
      .mantine-Accordion-content {
        padding: 1rem 0;
      }
    }
  }

  &[data-template='due-date'] {
    .accordion {
      .mantine-Accordion-control {
        &[aria-expanded='true'] {
          border-color: transparent;
        }
      }
      .mantine-Accordion-content {
        padding: 1rem;
        border-radius: 8px;
        background-color: ${(props) => props.bgContentColor};
      }
    }
  }

  &[data-template='category'] {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    gap: 16px;

    width: 360px;
    /* Neutral/Neutral-50 */
    background: ${theme.colors.neutral50};
    border-radius: 4px;
    ${MediaQueries.mbDown} {
      width: auto;
      margin-inline: -16px;
      margin-block: 24px;
    }
    .title-heading {
      padding-left: 16px;
      border-left: 5px solid ${theme.colors.primaryBase};
    }
    .accordion {
      .mantine-Accordion-control {
        padding: 16px;
        border-radius: 4px;
      }
      .mantine-Accordion-label {
        border-radius: 4px;
        overflow: unset;
      }
      .mantine-Accordion-item {
        background-color: #ffffff;
        border: none;
        margin-bottom: 2px;
        .mantine-Accordion-chevron {
          > div {
            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjk5OTcgMTQuMDcxTDguMTc4NjYgMTAuMjVDNy43NjQ2NiA5LjgzNTk1IDcuMDkyNjYgOS44MzU5NSA2LjY3ODY2IDEwLjI1QzYuMjY0NjYgMTAuNjY0IDYuMjY0NjYgMTEuMzM2IDYuNjc4NjYgMTEuNzVMMTEuMjkyNyAxNi4zNjRDMTEuNjgzNyAxNi43NTUgMTIuMzE2NyAxNi43NTUgMTIuNzA2NyAxNi4zNjRMMTcuMzIwNyAxMS43NUMxNy43MzQ3IDExLjMzNiAxNy43MzQ3IDEwLjY2NCAxNy4zMjA3IDEwLjI1QzE2LjkwNjcgOS44MzU5NSAxNi4yMzQ3IDkuODM1OTUgMTUuODIwNyAxMC4yNUwxMS45OTk3IDE0LjA3MVoiIGZpbGw9IiM1OTU5NTkiLz4KPC9zdmc+Cg==);
          }
        }
        &[data-active='true'] {
          .mantine-Accordion-chevron {
            > div {
              background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjcwNDMgOS45MjkwMkwxNS41MjUzIDEzLjc1QzE1LjkzOTMgMTQuMTY0IDE2LjYxMTMgMTQuMTY0IDE3LjAyNTMgMTMuNzVDMTcuNDM5MyAxMy4zMzYgMTcuNDM5MyAxMi42NjQgMTcuMDI1MyAxMi4yNUwxMi40MTEzIDcuNjM2MDJDMTIuMDIwMyA3LjI0NTAyIDExLjM4NzMgNy4yNDUwMiAxMC45OTczIDcuNjM2MDJMNi4zODMyNSAxMi4yNUM1Ljk2OTI1IDEyLjY2NCA1Ljk2OTI1IDEzLjMzNiA2LjM4MzI1IDEzLjc1QzYuNzk3MjUgMTQuMTY0IDcuNDY5MjUgMTQuMTY0IDcuODgzMjUgMTMuNzVMMTEuNzA0MyA5LjkyOTAyWiIgZmlsbD0iIzU5NTk1OSIvPgo8L3N2Zz4K);
            }
          }
        }
      }
      .mantine-Accordion-content {
        padding: 1rem;
        padding-top: 0;
        a {
          color: ${theme.colors.primaryBase};
        }
      }
    }
  }
`
